import { Fetcher } from './types'
import constants from '@constants'

const fetchGraphQL: Fetcher = async ({ query, variables }) => {
  const vars = { ...variables }
  vars.locale = vars.locale || constants.LOCALE
  vars.siteTag = vars.siteTag || constants.SITE_TAG

  const url = `https://graphql.contentful.com/content/v1/spaces/${constants.CONTENTFUL_SPACE_ID}`
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${constants.CONTENTFUL_ACCESS_TOKEN}`,
    },
    body: JSON.stringify({ query, variables: vars }),
  }

  const response = await fetch(url, options)
  const responseJson = await response.json()

  if (!/^20\d$/.test(String(response.status))) {
    console.log(
      `Error consuming GraphQL with variables ${JSON.stringify(variables)}`
    )
    responseJson?.errors?.forEach((error: any) => {
      console.log(error.message, error.extensions)
      const errorLocationsInGraphQLQuery = error.locations
      console.log({ errorLocationsInGraphQLQuery })
    })
  }

  return responseJson
}

export default fetchGraphQL
